exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".score {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  text-align: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 1em; }\n\n.score > div {\n  width: 3.5em;\n  overflow: hidden;\n  border-radius: 10px;\n  background: #AAC0AA;\n  margin: .5em; }\n\n.score > div > div,\n.score > div > span {\n  padding: .3em;\n  display: block; }\n\n.score > div > div {\n  background: #595959;\n  color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/score/score.component.scss
// module id = ../../../../../src/app/pages/home/mobx-tic-tac/tic-tac-toe/score/score.component.scss
// module chunks = main